import * as React from 'react';
import styled from 'styled-components';

import { Colors, Text } from '@origin-digital/style-guide';
import { getRegisterUrl } from 'ts/login/services/urlService';
import { HorizontalRule } from 'ts/components/HorizontalRule';

export const RegisterBlock: React.FC = () => (
  <>
    <HorizontalRule />
    <StyledText
      markdown={true}
      size="sm"
    >{`Never used My Account? [Register now](${getRegisterUrl()})`}</StyledText>
  </>
);

const StyledText = styled(Text)`
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${Colors.RED};
    text-decoration: none;
  }
`;
